export const SET_PRECHECK_TIME = 'SET_PRECHECK_TIME'

export const selectedTime = time => ({
	type: SET_PRECHECK_TIME,
	payload: time
})

export default function setPreCheckTime(reservationKey, timeVal) {
	let groupTime = {}

	// key times on change to reservationKey (confirmation groups)
	groupTime[reservationKey] = timeVal

	return dispatch => {
		dispatch(selectedTime(groupTime))
	}
}



// WEBPACK FOOTER //
// ./src/actions/setPreCheckTimeActions.js